import { z } from 'zod';
import { localeSchema } from '../common/primitives.js';
/** POST /auth/launch (unified-access.md section 3): redeems a one-time launch code. */
export const launchSchema = z.object({
    code: z.string().min(1, 'launch code is required'),
});
export const sessionUserSchema = z.object({
    id: z.string(),
    name: z.string(),
    /** English name; empty or missing means "use the Arabic name". */
    nameEn: z.string().optional(),
    username: z.string(),
});
export const sessionBranchSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    /** English name; empty or missing means "use the Arabic name". */
    nameEn: z.string().optional(),
});
/** The name to show for the language: English when present, Arabic otherwise. */
export function sessionDisplayName(entity, locale) {
    const english = entity.nameEn?.trim();
    return locale === 'en' && english ? english : entity.name;
}
/** Shared response of POST /auth/launch and GET /auth/me. */
export const sessionResponseSchema = z.object({
    user: sessionUserSchema,
    branch: sessionBranchSchema,
    services: z.array(z.string()),
    locale: localeSchema.optional(),
    /** Absolute session expiry, ISO (unified-access.md section 3.1). */
    expiresAt: z.iso.datetime({ offset: true }),
    /**
     * Time left on the session when this answer was built. The web app counts
     * it from when the answer arrived, so a wrong device clock does not matter.
     */
    expiresInMs: z.number().int().nonnegative(),
});
//# sourceMappingURL=auth.contract.js.map